<template>
  <div>
    <br />
    <h1 class="text-xs-center">Advanced: Beacon Settings</h1>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 md8 lg6 pa-2>
        <v-card>
          <v-card-title>
            <span class="headline">Assisted Beacon Registration Restriction</span>
          </v-card-title>
          <v-card-text>
            <v-alert :value="true" type="info" class="mb-3">
              When enabled, admin portal, agent app, and other assisted registration paths may only register a beacon for passengers who meet the ticket/top-up activity rule.
              <br /><br />A passenger is eligible if they have at least the configured minimum tickets/top-ups in the last week, or (when evaluation weeks is more than 1) at least that minimum plus one combined across the full lookback. For example, with 3 per week over 2 weeks: 3 in one week, or 4 across two weeks.
              <br /><br />Passenger self-registration through the passenger app is never restricted by this setting.
            </v-alert>
            <v-layout row wrap>
              <v-flex xs12 pa-1>
                <v-switch
                  v-model="restrictionEnabled"
                  label="Restrict assisted beacon registration"
                  color="primary"
                  :disabled="apiInProgress"
                />
              </v-flex>
              <v-flex xs12 sm6 pa-1>
                <v-select
                  v-model="minPurchasesPerWeek"
                  :items="minPurchasesPerWeekItems"
                  item-text="text"
                  item-value="value"
                  label="Minimum tickets/top-ups per week"
                  :disabled="apiInProgress || !restrictionEnabled"
                />
              </v-flex>
              <v-flex xs12 sm6 pa-1>
                <v-select
                  v-model="evaluationWeeks"
                  :items="evaluationWeeksItems"
                  item-text="text"
                  item-value="value"
                  label="Evaluation weeks (from current date)"
                  :disabled="apiInProgress || !restrictionEnabled"
                />
              </v-flex>
              <v-flex xs12 pa-1 v-if="dateUpdatedLabel">
                Date updated: {{ dateUpdatedLabel }}
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn color="warning" flat :disabled="apiInProgress || !isCurrentSettingsEdited" @click="cancelEdit()">
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn :disabled="apiInProgress" @click="loadSettings()">Reload</v-btn>
            <v-btn color="primary" :disabled="apiInProgress || !isCurrentSettingsEdited" :loading="apiInProgress" @click="saveSettings()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
